function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 0)"
}, React.createElement("path", {
  className: "a",
  d: "M18.539,2.461H8.419L7.189,0H0V18.539A2.464,2.464,0,0,0,2.461,21H18.539A2.464,2.464,0,0,0,21,18.539V4.922H18.539ZM3.691,18.539a1.23,1.23,0,0,1-2.461,0V1.23h5.2l1.23,2.461h9.65v1.23H3.691ZM19.77,6.152V18.539a1.232,1.232,0,0,1-1.23,1.23H4.592a2.446,2.446,0,0,0,.33-1.23V6.152Zm0,0"
}), React.createElement("path", {
  className: "a",
  d: "M182.846,189.383a1.838,1.838,0,0,0,1.175-.423l3.169,1.9A1.846,1.846,0,1,0,189,189.383a1.838,1.838,0,0,0-1.175.423l-3.169-1.9a1.855,1.855,0,0,0,0-.736l3.169-1.9a1.84,1.84,0,1,0-.634-1.055l-3.169,1.9a1.845,1.845,0,1,0-1.175,3.268Zm6.152,1.23a.615.615,0,1,1-.615.615A.616.616,0,0,1,189,190.613Zm0-7.383a.615.615,0,1,1-.615.615A.616.616,0,0,1,189,183.23Zm-6.152,3.691a.615.615,0,1,1-.615.615A.616.616,0,0,1,182.846,186.922Zm0,0",
  transform: "translate(-173.576 -174.535)"
}));

var SvgSharingContent = function SvgSharingContent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSharingContent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sharing-content.ca106c9e.svg";
export { ForwardRef as ReactComponent };